import { render, staticRenderFns } from "./request_account.vue?vue&type=template&id=326bfa27"
import script from "./request_account.vue?vue&type=script&lang=js"
export * from "./request_account.vue?vue&type=script&lang=js"
import style0 from "./request_account.vue?vue&type=style&index=0&id=326bfa27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports